export const DIGIO_SCRIPT = 'https://app.digio.in/sdk/v10/digio.js'